import * as React from 'react'
import {useEffect, useState} from 'react'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import {useTranslation} from 'react-i18next'
import '../css/carousel.css'

interface Audience {
    demo: string
    geoList: string[]
}

interface Block {
    title?: string
    text?: string
    img?: string
    audience?: Audience
}

interface CarouselOutlineProps {
    blocks: Block[]
    action?: (page: number) => void
    titleClass?: string
    textClass?: string
    style?: object
}

const CarouselOutline = (props: CarouselOutlineProps) => {

    const {t} = useTranslation('common')
    const [state, setState] = useState({innerWidth: window.innerWidth})

    useEffect(() => window.addEventListener('resize', () =>
        setState({innerWidth: window.innerWidth})), [])

    const isTablet = () => state.innerWidth > 544 && state.innerWidth < 1105

    const renderAudience = (audience: Audience) => (
        <div className="audience">
            <div className="block-p fw400">{t('Audience')}:</div>
            <div className="audience-container">
                <div className="audience-block">
                    <div className="audience-title">{t('Demo')}</div>
                    <div className="audience-text">{audience.demo}</div>
                </div>
                <div className="audience-block">
                    <div className="audience-title">{t('Geo')}</div>
                    <div className="audience-list">
                        {audience.geoList.map((geo, i) =>
                            <div key={'aud-' + i} className="audience-text">
                                {geo + (i != audience.geoList.length - 1 ? ',' : '')}
                            </div>)}
                    </div>
                </div>
                {/* <div className="audience-block"> */}
                {/* <div className="audience-title">{t('Gender')}</div> */}
                {/* <div className="audience-text">{audience.gender}</div> */}
                {/* </div> */}
            </div>
        </div>
    )

    const renderBlocks = () => {
        return props.blocks.map((block, index) => (
            <div key={'block-' + index} className="carousel-block bordered">
                <div className="carousel-image">
                    <img alt="" src={block.img} style={block.title == 'Offer Wall' ? {transform: 'scale(1.2)'} : {}} />
                </div>
                <div className={props.titleClass ? props.titleClass : 'block-p'}>{block.title}</div>
                <div className={props.textClass ? props.textClass : 'block-c'}>{block.text}</div>
                {block.audience != null ? renderAudience(block.audience) : null}
            </div>
        ))
    }

    return (
        <div className="carousel" style={props.style}>
            <div className="carousel-container">
                {isTablet()
                    ? <AliceCarousel
                        autoHeight={false}
                        buttonsDisabled={true}
                        infinite={false}
                        items={renderBlocks()} />
                    : renderBlocks()}
            </div>
        </div>
    )
}

export default CarouselOutline


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/carouselOutline.tsx